import { useEffect, useRef, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import {
    ExclamationCircleIcon,
    ExclamationTriangleIcon,
    PlusIcon,
} from "@heroicons/react/24/outline";
import Table from "../../components/Table";
import api from "../../api";
import { NewSurgeryForm } from "./Modals";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const columns = [
    { name: "patient.fullName", displayText: "Paciente", truncate: true },
    { name: "date", displayText: "Fecha" },
    { name: "invoice.invoiceNumber", displayText: "Nro. de facturación" },
    { name: "surgeon", displayText: "Cirujano" },
    { name: "assistant", displayText: "Ayudante" },
    { name: "anesthesiologist", displayText: "Anestesista" },
    { name: "invoice.serviceDescription", displayText: "cirugía a realizar" },
];

export function SurgeryPage() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [surgerySchedules, setSurgerySchedules] = useState([]);
    const [invoice, setInvoice] = useState(null);
    const newSurgeryRef = useRef(null);
    const navigate = useNavigate();
    const dialogRef = useRef(null);
    const [selectedRowId, setSelectedRowId] = useState(null);

    const handleOpenModal = (row) => {
        setSelectedRowId(row.id);
        checkInvoice(row.id);
        dialogRef.current?.showModal();
    };

    const handlePostAction = async () => {
        try {
            await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/surgery-schedules/${selectedRowId}/complete/`
            );
            setSurgerySchedules((prev) =>
                prev.filter((item) => item.id !== selectedRowId)
            );
        } catch (error) {
            console.error("Error al finalizar la cirugía:", error);
            alert(
                "Hubo un error al finalizar la cirugía. Inténtalo nuevamente."
            );
        } finally {
            dialogRef.current?.close();
        }
    };

    const checkInvoice = (id) => {
        const invoiceCheck = surgerySchedules.find(
            (item) => item.id === id
        )?.invoice;
        setInvoice(invoiceCheck);
    };

    useEffect(() => {
        setLoading(true);
        api.surgerySchedules
            .getMulti(null, null, null, null, {
                status: 1,
            })
            .then((response) => {
                const data = response;
                setSurgerySchedules(data);
                setLoading(false);
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="bg-gray-100 h-screen">
            <Sidebar
                currentScreen={"Cirugías"}
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
            />
            <div className="md:pl-64 flex flex-col h-screen flex-1">
                <>
                    <Header setSidebarOpen={setSidebarOpen} />
                    <main className="flex-1 space-y-6 bg-gray-100 py-8 px-6 lg:px-8">
                        <LocalHeader dialogRef={newSurgeryRef} />
                        {loading ? (
                            <div className="flex h-full items-center justify-center ">
                                <div className="w-16 h-16 border-b-2 border-blue-900 rounded-full animate-spin"></div>
                            </div>
                        ) : (
                            <div className="">
                                <Table
                                    module="patients"
                                    columns={columns}
                                    rows={surgerySchedules}
                                    navigate={navigate}
                                    path="surgeries"
                                    openModal={handleOpenModal}
                                    openModalText="Finalizar"
                                />
                                <dialog ref={dialogRef} className="rounded-lg">
                                    <InvoiceData
                                        dialogRef={dialogRef}
                                        invoice={invoice}
                                        handlePostAction={handlePostAction}
                                    />
                                </dialog>
                            </div>
                        )}
                    </main>
                </>
            </div>
            <dialog
                ref={newSurgeryRef}
                id="new-surgery"
                closedby="any"
                className="rounded-lg overflow-visible"
            >
                <NewSurgeryForm
                    dialogRef={newSurgeryRef}
                    setSurgerySchedules={setSurgerySchedules}
                />
            </dialog>
        </div>
    );
}

const LocalHeader = (props) => {
    const openDialog = () => {
        props.dialogRef.current?.showModal();
    };
    const [userRole, setUserRole] = useState(
        JSON.parse(localStorage.getItem("BDOuserData"))?.role
    );
    return (
        <div className="flex flex-col gap-5 lg:flex-row justify-between items-start">
            <h2 className="text-gray-600 text-4xl font-bold">
                Agendamiento de cirugías
            </h2>
            {(userRole === 2 || userRole === 4) && (
                <button
                    className="flex items-center gap-2 mr-2 sm:mr-8 lg:mr-16 px-4 py-2 border border-transparent shadow-sm text-sm font-semibold rounded-md text-white bg-primary hover:bg-primary"
                    onClick={openDialog}
                >
                    <PlusIcon className="h-6 w-6" /> <span>Nueva cirugía</span>
                </button>
            )}
        </div>
    );
};

const InvoiceData = (props) => {
    const closeDialog = () => {
        props.dialogRef.current?.close();
    };
    return (
        <>
            <div className="p-6 lg:w-[446px] min-h-[440px]">
                {props.invoice ? (
                    <div className="flex flex-col items-center gap-3">
                        <div className="flex flex-col items-center">
                            <div className="bg-[#FFBB3D40] p-2 rounded-full ">
                                <ExclamationTriangleIcon className="h-6 w-6 text-[#FFBB3D]" />
                            </div>
                            <h2 className="font-semibold">
                                ¿Desea finalizar esta ciruguía?
                            </h2>
                        </div>
                        <div className="flex flex-col items-center">
                            <b className="text-gray-800">Paciente</b>
                            <span className="text-gray-600">
                                {props.invoice.name}
                            </span>
                        </div>
                        <div className="flex flex-col items-center">
                            <b className="text-gray-800">Razón social</b>
                            <span className="text-gray-600">
                                {props.invoice.socialReason}
                            </span>
                        </div>
                        <div className="flex flex-col items-center">
                            <b className="text-gray-800">Cirugía a realizar</b>
                            <span className="text-gray-600">
                                {props.invoice.serviceDescription}
                            </span>
                        </div>
                        <div className="w-full">
                            <button
                                onClick={props.handlePostAction}
                                className="w-full mt-6 flex justify-center items-center px-4 py-2 border border-transparent shadow-sm text-sm font-semibold rounded-md text-white bg-primary hover:bg-primary"
                            >
                                Finalizar
                            </button>
                            <button
                                type="button"
                                onClick={closeDialog}
                                className="w-full mt-6 flex justify-center items-center px-4 py-2 border border-gray-500 shadow-sm text-sm font-semibold rounded-md text-gray-800 bg-white"
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                ) : (
                    <div className="w-full h-full justify-between items-center flex flex-col">
                        <div className="flex mt-20 flex-col gap-5 items-center">
                            <div className="bg-[#FFF1F0] p-2 rounded-full ">
                                <ExclamationCircleIcon className="h-20 w-20 text-[#FF4D4F]" />
                            </div>
                            <h2 className="font-semibold text-center text-3xl">
                                No se ha encontrado la factura
                            </h2>
                        </div>
                        <button
                            type="button"
                            onClick={closeDialog}
                            className="w-full mt-6 flex justify-center items-center px-4 py-2 border border-gray-500 shadow-sm text-sm font-semibold rounded-md text-gray-800 bg-white"
                        >
                            Volver
                        </button>
                    </div>
                )}
            </div>
        </>
    );
};
